import { useNavigate, useRouter } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

type GeneralErrorProps = React.HTMLAttributes<HTMLDivElement> & {
  minimal?: boolean
  /** Erro recebido pelo error boundary do router (em dev mostra detalhes) */
  error?: unknown
}

export function GeneralError({
  className,
  minimal = false,
  error,
}: GeneralErrorProps) {
  const navigate = useNavigate()
  const { history } = useRouter()
  const isDev = import.meta.env.DEV
  return (
    <div className={cn('h-svh w-full', className)}>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        {!minimal && (
          <h1 className='text-[7rem] leading-tight font-bold'>500</h1>
        )}
        <span className='font-medium'>Ops! Algo deu errado {`:')`}</span>
        <p className='text-muted-foreground text-center'>
          Pedimos desculpas pelo inconveniente. <br /> Por favor, tente novamente mais tarde.
        </p>
        {isDev && error != null && (
          <pre className='mt-4 max-w-2xl overflow-auto rounded border bg-muted p-3 text-left text-xs'>
            {error instanceof Error ? error.message : String(error)}
            {error instanceof Error && error.stack && `\n\n${error.stack}`}
          </pre>
        )}
        {!minimal && (
          <div className='mt-6 flex gap-4'>
            <Button variant='outline' onClick={() => history.go(-1)}>
              Voltar
            </Button>
            <Button onClick={() => navigate({ to: '/' })}>Ir para Home</Button>
          </div>
        )}
      </div>
    </div>
  )
}
